// import * as Base from './fire.base'
import * as Base from '../../game/firebase'
import * as FireAuth from '../../game/auth'
import * as THREE from 'three'
export const makeRoot = () => {
  return {
    xnum: 1,
    ynum: 1,
    bricks: [
    ],
    xymap: {}
  }
}

export const makeBrick = (root, xmax, ymax) => {
  let { bricks } = root
  root.xnum = xmax
  root.ynum = ymax
  for (var row = 0; row < xmax; row++) {
    for (var column = 0; column < ymax; column++) {
      let item = {
        numID: bricks.length,
        xid: column,
        yid: row,
        color: '#ff0000',
        belongsTo: 'nobody',
        toBeRemoved: false
      }
      bricks.push(item)
      root.xymap[item.xid + '-' + item.yid] = item
    }
  }
}

export const getGameData = ({ gameID }) => {
  return new Promise((resolve, reject) => {
    Base.FDB.ref(`/user-games/${gameID}`).once('value', (snap) => {
      let room = snap.val()
      if (room) {
        resolve(room)
      } else {
        Base.FDB.ref(`/admin-games/${gameID}`).once('value', (snap) => {
          let room = snap.val()
          if (room) {
            resolve(room)
          } else {
            reject(new Error('no room detected'))
          }
        })
      }
    })
  })
}

export const makeSureReady = ({ gameID, readyNow, redirectTo }) => {
  if (gameID) {
    Base.FDB.ref(`/user-games/${gameID}`).once('value', (snap) => {
      let room = snap.val()
      if (room) {
        readyNow()
      } else {
        Base.FDB.ref(`/admin-games/${gameID}`).once('value', (snap) => {
          let room = snap.val()
          if (room) {
            readyNow()
          } else {
            redirectTo('/game-lobby')
          }
        })
      }
    })
  } else {
    redirectTo('/game-lobby')
  }
}

export const listAllPlayers = ({ gameID, onArrive }) => {
  Base.FDB.ref(`/players/${gameID}/players`).on('value', (snap) => {
    let result = Base.toArr(snap.val())
    // console.log(result)
    onArrive({ result })
  })
}

export const getMyUID = async () => {
  await FireAuth.waitTilLoggedIn()
  let userID = FireAuth.State.user.uid
  return userID
}

export const getPlayerSelfGameID = async ({ gameID }) => {
  let userID = await getMyUID()
  return new Promise((resolve) => {
    console.log(userID)
    Base.FDB.ref(`/players/${gameID}/players/${userID}/gameID`).once('value', (snap) => {
      // console.log('----')
      resolve(snap.val())
    })
  })
}

export const initMyself = async ({ root, gameID }) => {
  await FireAuth.waitTilLoggedIn()
  let State = FireAuth.State
  return new Promise(async (resolve, reject) => {
    Base.FDB.ref(`/players/${gameID}/activeTiles`).once('value', (snap) => {
      // let activeTiles = Base.toArr(snap.val())
      let newColor = new THREE.Color()
      newColor.setHSL(Math.random(), 1.0, 0.5)
      let range = root.bricks
      // .filter(b => !activeTiles.map(a => a.numID).includes(b.numID))
      let randomBrick = range[Math.floor(range.length * Math.random())] || root.bricks[0]
      let newCellCore = JSON.parse(JSON.stringify(randomBrick))
      newCellCore.belongsTo = State.user.uid
      newCellCore.color = '#' + newColor.getHexString()

      Base.FDB.ref(`/players/${gameID}/players/${State.user.uid}`).set({
        gameID: gameID,
        userID: State.user.uid,
        displayName: State.user.displayName || window.prompt('Please enter your nickname.') || '',
        myColor: '#' + newColor.getHexString(),
        gameInfo: {
          cellCore: newCellCore
        }
      })

      resolve({ newCellCore, myColor: newColor })
    })
  })
}

export const joinGame = async ({ root, gameID }) => {
  await FireAuth.waitTilLoggedIn()
  let State = FireAuth.State
  return new Promise((resolve, reject) => {
    Base.FDB.ref(`/players/${gameID}/players/${State.user.uid}/gameID`).once('value', async (snap) => {
      let result = snap.val()
      console.log(result)
      // if (State.user.displayName) {
      //   Base.FDB.ref(`/players/${gameID}/players/${State.user.uid}/displayName`).set(State.user.displayName)
      // }

      if (!result) {
        let { newCellCore } = await initMyself({ root, gameID })

        // return myself
        Base.FDB.ref(`/players/${gameID}/players/${State.user.uid}`).once('value', async (snap) => {
          let myself = snap.val()
          // cell core
          await setTileToMineProperly({ gameID, numID: newCellCore.numID, tile: newCellCore, activeTiles: [], players: [] })

          // let map = root.xymap
          // let cell = newCellCore
          // // around
          // let found = [
          //   map[cell.xid + '-' + cell.yid],
          //   map[(cell.xid + 1) + '-' + (cell.yid + 1)],
          //   map[(cell.xid - 1) + '-' + (cell.yid - 1)],
          //   map[(cell.xid + 1) + '-' + (cell.yid - 1)],
          //   map[(cell.xid - 1) + '-' + (cell.yid + 1)],

          //   map[(cell.xid + 0) + '-' + (cell.yid + 1)],
          //   map[(cell.xid + 0) + '-' + (cell.yid - 1)],
          //   map[(cell.xid + 1) + '-' + (cell.yid + 0)],
          //   map[(cell.xid - 1) + '-' + (cell.yid + 0)]
          // ].filter(e => e)

          // let updates = {}
          // found.forEach((protector, idx) => {
          //   protector.belongsTo = myself.userID
          //   protector.color = myself.myColor
          //   protector.dead = false
          //   protector.lastCaptureTime = new Date().getTime()

          //   if (idx !== 0) {
          //     protector.upgradeLevel = 1
          //   }

          //   updates[`/players/${gameID}/activeTiles/${protector.numID}`] = protector
          // })

          // Base.FDB.ref().update(updates)

          // await setTileToMineProperly({ gameID, numID: newCellCore.numID, tile: newCellCore, myColor, players: [], activeTiles: [], root: root })
          resolve(myself)
          // Analytics.logJoinGame({ gameID, playerID: State.user.uid, displayName: State.user.displayName })
        })
      } else {
        // rettnr myself
        Base.FDB.ref(`/players/${gameID}/players/${State.user.uid}`).once('value', (snap) => {
          let myself = snap.val()
          resolve(myself)
          // Analytics.logJoinGame({ gameID, playerID: State.user.uid, displayName: State.user.displayName })
        })
      }
    })
  })
}

export const getMyPlayerSelf = async ({ gameID }) => {
  await FireAuth.waitTilLoggedIn()
  let State = FireAuth.State
  return new Promise((resolve) => {
    Base.FDB.ref(`/players/${gameID}/players/${State.user.uid}`).once('value', (snap) => {
      resolve(snap.val())
      // TODO
      // Analytics.logJoinGame({ gameID, playerID: State.user.uid, displayName: State.user.displayName })
    })
  })
}

export const onTilesArrive = async ({ gameID, onArrive = () => {}, onCellCoreDestroy = () => {} }) => {
  let userID = await getMyUID()
  Base.FDB.ref(`/players/${gameID}/activeTiles`).on('value', (snap) => {
    let activeTiles = Base.toArr(snap.val())
    onArrive(activeTiles)
  })

  // Base.FDB.ref(`/players/${gameID}/players/${userID}`).on('child_changed', (snap) => {
  //   onUpdateMe(snap.val())
  // })
  Base.FDB.ref(`/players/${gameID}/killedBy/${userID}`).remove()
  Base.FDB.ref(`/players/${gameID}/killedBy/${userID}`).on('value', (snap) => {
    let val = snap.val()
    // FDB.ref(`/players/${gameID}/killedBy/${val}`).remove()
    onCellCoreDestroy(val)
    // FDB.ref(`/players/${gameID}/killedBy/${userID}`).remove()
  })

  // .on('value', (snap) => {
  //   onUserListArrive(toArr(snap.val()))
  // })
  // FDB.ref(`/players/${gameID}/activeTiles`).on('child_added', () => {
  //   onRefresh()
  // })
  // FDB.ref(`/players/${gameID}/activeTiles`).on('child_changed', () => {
  //   onRefresh()
  // })
  // FDB.ref(`/players/${gameID}/activeTiles`).on('child_moved', () => {
  //   onRefresh()
  // })
  // FDB.ref(`/players/${gameID}/activeTiles`).on('child_removed', () => {
  //   onRefresh()
  // })
}

export const saveTile = ({ gameID, numID, tile }) => {
  return new Promise((resolve, reject) => {
    Base.FDB.ref(`/players/${gameID}/activeTiles/${numID}`).set(tile)
    resolve(tile)
  })
}

export const saveTileList = ({ gameID, tileList }) => {
  return new Promise((resolve, reject) => {
    let updates = {}
    tileList.forEach((tile) => {
      updates[`/players/${gameID}/activeTiles/${tile.numID}`] = tile
    })
    Base.FDB.ref().update(updates, (err) => {
      if (err) {
        console.error(err)
        reject(err)
      } else {
        resolve()
      }
    })
  })
}

// // export const captureCellCore = async ({ players, numID, activeTiles }) => {
// // }

export const upgradeCell = ({ cell, gameID }) => {
  let maxLevel = 1
  Base.FDB.ref(`/players/${gameID}/activeTiles/${cell.numID}/upgradeLevel`).once('value', (snap) => {
    let val = snap.val()
    if (val === null) {
      Base.FDB.ref(`/players/${gameID}/activeTiles/${cell.numID}/upgradeLevel`).set(1)
    }
    if (typeof val === 'number' && val < maxLevel) {
      Base.FDB.ref(`/players/${gameID}/activeTiles/${cell.numID}/upgradeLevel`).set(val + 1)
    }
  })
}

export const downgradeCell = ({ cell, gameID }) => {
  let minLevel = 0
  Base.FDB.ref(`/players/${gameID}/activeTiles/${cell.numID}/upgradeLevel`).once('value', (snap) => {
    let val = snap.val()
    if (typeof val === 'number' && val > minLevel) {
      Base.FDB.ref(`/players/${gameID}/activeTiles/${cell.numID}/upgradeLevel`).set(val - 1)
    }
  })
}

export const cleanUpPlayer = ({ gameID, player }) => {
  return new Promise((resolve) => {
    Base.FDB.ref(`/players/${gameID}/players/${player.userID}`).remove()
    resolve()
  })
}

export const adminResetCell = async ({ gameID, cell }) => {
  removeDeadCells({ deadCells: [cell], gameID })
}

export const removeDeadCells = ({ deadCells, gameID }) => {
  let updates = {
  }
  deadCells.forEach((dc) => {
    updates[`/players/${gameID}/activeTiles/${dc.numID}/dead`] = true
    updates[`/players/${gameID}/activeTiles/${dc.numID}/upgradeLevel`] = 0
  })
  Base.FDB.ref().update(updates)
}

export const setTileToMineProperly = async ({ gameID, numID, tile, activeTiles, players }) => {
  let myself = await getMyPlayerSelf({ gameID })
  let userID = await getMyUID()
  let cores = players.map(p => p.gameInfo.cellCore)
  // if we want to capture a core.
  if (cores.some(c => c.numID === numID)) {
    let player = players.find(p => p.gameInfo.cellCore.numID === numID)

    // FDB.ref(`/players/${gameID}/players/${player.userID}/removedBy`).set(State.user.uid).then(() => {
    // })
    // show poop
    // killedBy
    Base.FDB.ref(`/players/${gameID}/killedBy/${player.userID}`).set(JSON.parse(JSON.stringify(userID)))

    // clean up game chararcter info info, not active tiles
    cleanUpPlayer({ gameID, player })

    let list = activeTiles.filter(a => a.belongsTo === player.userID).map((userTile) => {
      userTile.belongsTo = userID
      userTile.color = myself.myColor
      userTile.lastCaptureTime = new Date().getTime()
      userTile.dead = false
      userTile.toBeRemoved = false
      return userTile
    })

    //
    await saveTileList({ gameID, tileList: list })

    // let randomBrick = root.bricks.filter(b => b.belongsTo === 'nobody')[Math.floor(root.bricks.length * Math.random())]
    // let newCellCore = JSON.parse(JSON.stringify(randomBrick))
    // newCellCore.belongsTo = player.userID
    // newCellCore.color = player.myColor
    // newCellCore.dead = false
    // tile.lastCaptureTime = new Date().getTime()

    // FDB.ref(`/players/${gameID}/players/${player.userID}/gameInfo/cellCore`).set(newCellCore)
    // // FDB.ref(`/players/${gameID}/players/${player.userID}/gameInfo/cellCore`).set(newCellCore)
    // FDB.ref(`/players/${gameID}/activeTiles/${newCellCore.numID}`).set(JSON.parse(JSON.stringify(newCellCore)))

    // let randomBrick = root.bricks.filter(b => b.belongsTo === 'nobody')[Math.floor(root.bricks.length * Math.random())]
    // let newCellCore = JSON.parse(JSON.stringify(randomBrick))
    // newCellCore.belongsTo = State.user.uid
    // FDB.ref(`/players/${gameID}/players/${State.user.uid}/gameInfo/cellCore`).set(newCellCore)
  } else {
    tile.belongsTo = userID
    console.log(tile.belongsTo)
    tile.color = myself.myColor
    tile.dead = false
    tile.lastCaptureTime = new Date().getTime()

    await saveTile({ gameID, numID, tile })
  }
  // tile.belongsTo = State.user.uid
  // console.log(tile.belongsTo)
  // tile.color = myColor
  // tile.dead = false
  // tile.lastCaptureTime = new Date().getTime()

  // await saveTile({ gameID, numID, tile })
}
